import { gql } from '@apollo/client'

export default gql(`
    mutation deleteLanguage($id: ID!, $name: String, $project: String) {
        deleteLanguage(
                id: $id,
                name: $name,
                project: $project
        ) {
            id
            name
        }
    }`
)
